<template>
    <div>
        <hts-card title="Sản lượng phân bổ đơn hàng">
            <hts-loading :loading="loading">
                <div class="mt-5 grid grid-cols-1 sm:grid-cols-4 gap-x-4 gap-y-8">
                    <analytics-card
                        text="Chờ phân bổ (chuyến)"
                        :value="$formatters.formatCurrency(dataAnalytics.totalAwaitingAllocation)"
                        color="warning"
                        increase />
                </div>
                <div class="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-2 gap-y-8">
                    <hts-analytics-card-chart
                        v-if="!loading"
                        class="min-h-[365px]"
                        title="Đơn hàng chưa hoàn tất phân bổ"
                        :labels="dataAnalytics.ordersPendingAllocation.labels"
                        :series="[{ name: 'Đơn hàng chưa hoàn tất phân bổ', data: dataAnalytics.ordersPendingAllocation.series }]" />
                    <hts-analytics-card-chart
                        v-if="!loading"
                        class="min-h-[365px]"
                        title="Chặng hàng chưa có xe chính thức"
                        :labels="dataAnalytics.pendingAllocationJourneys.labels"
                        :series="[{ name: 'Chặng hàng chưa có xe chính thức', data: dataAnalytics.pendingAllocationJourneys.series }]" />
                </div>
            </hts-loading>
        </hts-card>
    </div>
</template>
<script lang="ts" setup>
import AnalyticsCard from './analytics-card'
import { $api, $lodash } from '#imports'
const loading = ref(false)
const dataAnalytics = ref<{
  totalAwaitingAllocation: number
  ordersPendingAllocation: { labels: Array<{ [key: string]: any }>; series: Array<any> }
  pendingAllocationJourneys: { labels: Array<{ [key: string]: any }>; series: Array<any> }
}>({
  totalAwaitingAllocation: 0,
  ordersPendingAllocation: { labels: [], series: [] },
  pendingAllocationJourneys: { labels: [], series: [] }
})

onMounted(async () => {
  loading.value = true
  const api = $url.analysis.getOrderAllocationaVolume
  const data: any = await $api(api)
  const resData: any = $lodash.get(data, 'data.value')
  if (resData?.success) {
    dataAnalytics.value = resData.data
  }
  loading.value = false
})
</script>
